import { useQuery } from '@tanstack/react-query';

import Client from './client';

import type { UseQueryOptions } from '@tanstack/react-query';

export const useBulletinBoards = (
  {
    codes,
    partnerId,
    distributor,
  }: { codes: string; partnerId?: string; distributor?: string },
  options: Omit<
    UseQueryOptions<Awaited<ReturnType<typeof Client.fetchBulletinBoards>>>,
    'queryFn' | 'queryKey'
  > = {},
) => {
  const { data, status, error } = useQuery({
    queryKey: ['bulletin_boards', { codes, partnerId, distributor }],
    queryFn: () =>
      Client.fetchBulletinBoards({ codes, partnerId, distributor }),
    refetchInterval: false,
    enabled: !!codes,
    ...options,
  });

  const bulletinBoards = data?.data?.data ?? null;

  return {
    bulletinBoards,
    getBulletinBoardsStatus: status,
    getBulletinBoardsError: error,
  };
};
